import {Component, Input} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {IYii} from '../../../../globals';
import {CommonModule} from '@angular/common';
import {NgSelectModule} from '@ng-select/ng-select';
import {BranchInformationFields} from '../../constants/branch-information-fields';

declare var Yii: IYii;

@Component({
  selector: 'ng-field-branch-information',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    NgSelectModule
  ],
  template: `
    <div class="form-row">
      <label></label>
      <div>
        <strong class="text-danger">
          This field will only be visible in MNG app and not visible in backend and BOSS app!!!
        </strong>
      </div>
    </div>
    <div class="form-row flex-align-center">
      <label>{{ Yii.t('app', 'Source Field') }}</label>
      <div>
        <ng-select
          [items]="branchInformationFields"
          bindLabel="tag"
          bindValue="key"
          style="max-width: 480px"
          [multiple]="true"
          [hideSelected]="true"
          placeholder="Select..."
          appendTo="body"
          [(ngModel)]="field.source_field">
        </ng-select>
      </div>
    </div>
  `,
})
export class FieldBranchInformation {
  Yii = Yii;
  @Input() field: any;
  branchInformationFields = BranchInformationFields;
}
